export default __webpack_public_path__ + "static/gatsby_github_get_pat2-ee30d2c2dd1929c402f5879270426caf.png";